<main class="space-y-1 text-start">
  <h2 class="page-title"> <i [routerLink]="['/products', productId]" class="bi text-[#8A8AA3] text-sm cursor-pointer" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i> <a [routerLink]="['/products', productId]" class="text-[#8A8AA3] ms-2 me-2">{{ 'products.back' | translate }} </a> {{ 'products.edit_page_title' | translate }}
  </h2>

    <div *ngIf="!productsResponse" class="animate-pulse">

      <div class="w-full bg-[#F6F6F6] rounded-lg p-4 flex max-xl:flex-col gap-6">

        <div class="w-full xl:w-2/5">
          <div class="bg-gray-200 rounded-xl h-[340px] w-full"></div>
        </div>

        <div class="w-full flex flex-col gap-5">

          <div class="space-y-2">
            <div class="bg-gray-200 h-4 w-32 rounded"></div>
            <div class="bg-gray-200 h-11 rounded-lg w-full"></div>
          </div>

          <div class="space-y-2">
            <div class="bg-gray-200 h-4 w-28 rounded"></div>
            <div class="bg-gray-200 h-11 rounded-lg w-full"></div>
          </div>

          <div class="space-y-2">
            <div class="bg-gray-200 h-4 w-24 rounded"></div>
            <div class="bg-gray-200 h-11 rounded-lg w-full"></div>
          </div>

          <div class="space-y-2">
            <div class="bg-gray-200 h-4 w-36 rounded"></div>
            <div class="bg-gray-200 h-11 rounded-lg w-full"></div>
          </div>

          <div class="flex justify-start gap-2 flex-wrap mt-2">
            <div
              *ngFor="let i of [1,2,3,4,5]"
              class="bg-gray-200 rounded-md h-8 w-20">
            </div>
          </div>

          <div class="bg-gray-200 rounded-xl h-[180px] mt-3"></div>

          <div class="flex justify-between mt-5">
            <div class="bg-gray-200 h-10 w-32 rounded-lg"></div>
            <div class="bg-gray-200 h-10 w-32 rounded-lg"></div>
          </div>

        </div>
      </div>
    </div>

  <div class="mt-5 flex flex-col gap-3">
    <app-product-form *ngIf="productsResponse" (formSubmit)="submit($event)" [isDrawer]="false" [productData]="productsResponse!"
      [disableSubmitButton]="disableSubmitButton" [loading]="loading"></app-product-form>
  </div>
</main>
